/**
 * Banner Ad Scripts - Previously MMF.Ads
 *
 * @todo - googletags
 */

mmf_modules.define('utils/ads',[
    'context_vars/utils/ads',
    'jquery',
    'utils/utils',
    'utils/site',
    'utils/user'
], function (
    context,
    $,
    utils,
    Site,
    User
) {
    "use strict";

    var Ads = utils.extend(true, {}, context);

    Ads.refresh_interval = null;
    Ads.refresh_delay = 4 * 60 * 1000; // 4 minutes

    // restrict refresh to only a few categories
    Ads.refresh_categories = [
        "maps_routes",
        "events",
        "groups"
    ];

    Ads.allow_refresh = function () {
        var allow = $.inArray(Site.category, Ads.refresh_categories) !== -1;

        return allow;
    };

    Ads.Init = function () {
        $('.ad_iframe').each(function () {
            $(this).attr("src", $(this).attr('data-ad-source'));
        });

        function startInterval () {
            if (!Ads.refresh_interval) {
                Ads.refresh_interval = setInterval(function () {
                    Ads.Refresh();
                }, Ads.refresh_delay);
            }
        }

        // only refresh if we're in a certain set of categories
        if (Ads.allow_refresh()) {
            startInterval();
        }
    };

    Ads.Refresh = function () {
        // @todo figure out what this is and convert it to a module
        var googletag = window.googletag;
        if (!User.is_mvp && Ads.allow_refresh()) {
            if (googletag && googletag.pubads) {
                googletag.pubads().refresh();
            }
        }
    };


    Ads.manualRefresh = function (slotArray) {
        /**
            Refresh specific, or all, DFP ad slots defined on the page.
            This function accepts an array of DFP Ad Slots, for example:
                window.slots
            Otherwise, it will use window.slots as default to find all
            defined DFP ads cached in our global object. This is the
            most likely usage scenario.
         */
        if (User.can_see_ads && 'googletag' in window) {
            if (!Array.isArray(slotArray)) {
                // If an array of slots wasn't passed, then gather all slots into an array.
                slotArray = (function (slots) {
                    var arr = [], s;
                    for (s in slots) {
                        if (slots.hasOwnProperty(s)) { arr.push(slots[s]); }
                    }
                    return arr;
                }(window.googletag.pubads().getSlots()));
            }
            // Do the refresh if we have googletag available.
            if ('googletag' in window && typeof window.googletag.pubads === 'function') {
                window.googletag.pubads().refresh(slotArray);
            }
        }
    };

    Ads.getSlotsByDimensions = function (dimensions) {
        /**
            Retrieve ad slots by dimensions for targeting in other functions.
         */
        var allSlots = [],
            slot = null,
            curSlotSizes = [],
            matchedSlots = [],
            curSlot = {};

        if ('googletag' in window && typeof window.googletag.pubads === 'function') {
            allSlots = window.googletag.pubads().getSlots();
        } else {
            return [];
        }

        // Verify we got a height and width to target or return false.
        if (!('width' in dimensions) || !('height' in dimensions)) {
            return false;
        }

        for (slot in allSlots) {
            if (allSlots.hasOwnProperty(slot)) {
                curSlotSizes = allSlots[slot].getSizes();
                for (var i = 0; i < curSlotSizes.length; i++) {
                    if (curSlotSizes[i].getHeight() === dimensions.height && curSlotSizes[i].getWidth() === dimensions.width) {
                        matchedSlots.push(allSlots[slot]);
                        break;
                    }
                }
            }
        }

        return matchedSlots;
    };

    return Ads;
});
